var React = require('react');

function Ig (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h32v32H0z","key":0}),React.createElement("path",{"d":"M23.5 4.5A4.5 4.5 0 0128 9v14a4.5 4.5 0 01-4.5 4.5h-14A4.5 4.5 0 015 23V9a4.5 4.5 0 014.5-4.5h14zm-7 5.25a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zm0 1.5a4.75 4.75 0 11.001 9.499 4.75 4.75 0 01-.001-9.499zm7-3.75a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0023.5 7.5z","fill":"currentColor","fillRule":"nonzero","key":1})]));
}

Ig.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Ig;

Ig.default = Ig;
